import { renderNamedSlot } from 'src/utils/component';
function APIHandler({ requestState, LoaderComponent, renderData, renderError, }) {
    if (requestState.data !== undefined && requestState.data !== null) {
        return renderData(requestState);
    }
    else if (requestState.loading) {
        return renderNamedSlot(LoaderComponent);
    }
    else if (requestState.error) {
        return renderError(requestState);
    }
    return null;
}
export default APIHandler;
